import { Component, OnInit } from "@angular/core";
import {
  ESTATUS_CARD_DATA,
  RESPONSE_TRACKING,
} from "@constants/tramite-pension-constant";
import { IEstadoTramitePensionResponse } from "@interfaces/estado-tramite-pension.response.interface";
import { StorageService } from "@services/storage/storage.service";
import { EstadoTramiteStepperService } from "../../services/estado-tramite-stepper.service";
import { CODIGO_MODALIDAD_PENSION } from '../../../shared/common/constants/tramite-pension-constant';

@Component({
  selector: "app-pago-pension",
  templateUrl: "./pago-pension.component.html",
  standalone: false
})
export class PagoPensionComponent implements OnInit {
  statusCardData = ESTATUS_CARD_DATA[4];
  esCompaniaSeguro: boolean = false;

  constructor(
    private readonly tramiteStepper: EstadoTramiteStepperService,
    private readonly storageService: StorageService,
  ) { }

  async ngOnInit() {
    this.tramiteStepper.setStepCurrent(5);
    await this.cargarInfoBoxPagoPension();
  }

  private async cargarInfoBoxPagoPension() {
    const responseTracking: IEstadoTramitePensionResponse =
      await this.storageService.get(RESPONSE_TRACKING);
    this.esCompaniaSeguro = responseTracking?.data?.modalidadPension?.tipoModalidad === CODIGO_MODALIDAD_PENSION.RVI;
  }

}
